import { MdDeleteForever, MdModeEdit } from "react-icons/md";
import { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance.js";
import { useLocation, useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import Loader from "../../common/Loader/index.js";
import Select from "react-select";
import Model from "../../common/Model/index.js";
import { notify, Toast } from "../../common/Toast/index.js";
import { FaStarOfLife } from "react-icons/fa";
import FormFields from "../../common/FormFields/index.js";
import { getUserMenuPermission } from "../../common/Helper/index.js";

const ManualDetails = () => {
  const today = new Date().toISOString()?.split("T")[0];
  const permission = getUserMenuPermission(9);
  const navigate = useNavigate();
  const location = useLocation();
  const { manualDetailsData } = location.state || {};
  const [errors, setErrors] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [quotation, setQuotation] = useState({
    quotation_No: 0,
    quotation_Date: today,
    site_Id: "",
    stage_Id: 1,
    gross_Amount: 0,
    disc_Per: 0,
    disc_Amount: 0,
    gsT_Per: 18,
    gsT_Amount: 0,
    trasportation: 0,
    packing_Charge: 0,
    net_Amount: 0,
    remark: "",
    company_Id: "",
    stageId: null,
    finalAmount: "",
    finalProfileColor: "",
    glassColorType: "",
    workCompleteDate: "",
    reason: "",
    quote_Amount: "",
  });
  const [terms, setTerms] = useState([]);
  const [items, setItems] = useState([
    {
      item_Code: 0,
      item_Name: "",
      hsn_Sac: "",
      description: "",
      qty: 0,
      rate: 0,
      total_Amount: 0,
      image: null,
      isEditingDescription: false,
    },
  ]);
  const [newItem, setNewItem] = useState({
    item_Code: 0,
    item_Name: "",
    description: "",
    item_Rate: 0,
    item_Face: 0,
    item_Type: "",
    coil_Used: "",
    thickness: 0,
    image: null,
  });
  const [isSiteDetailsData, setIsSiteDetailsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [company, setCompany] = useState([]);
  const [allItems, setAllItems] = useState([]);
  const [isItemModalOpen, setIsItemModalOpen] = useState(false);
  const [isItemType, setIsItemType] = useState([]);
  const [isCoilData, setIsCoilData] = useState([]);
  const userId = sessionStorage.getItem("userId");
  const { selectedSite } = location.state || {};

  useEffect(() => {
    fetchSiteData();

    if (selectedSite) {
      setQuotation((prev) => ({
        ...prev,
        site_Id: selectedSite.site_Id?.toString(),
      }));
    }
    if (!manualDetailsData) {
      fetchTermsData();
    }
  }, []);

  const fields = [
    {
      name: "item_Name",
      label: "Item Name",
      type: "text",
      required: true,
      errorMessage: "Item name is required",
    },
    { name: "description", label: "Description", type: "text" },
    {
      name: "item_Rate",
      label: "Item Rate",
      type: "number",
      required: true,
      min: 0,
      step: 0.01,
      errorMessage: "Positive value required",
    },
    { name: "item_Face", label: "Item Face", type: "number" },
    {
      name: "item_Type",
      label: "Item Type",
      type: "select",
      id: "item_Type",
      options: isItemType.map((type) => ({
        value: type.item_Type.toString(),
        label: type.item_Type_Name,
      })),
    },
    {
      name: "coil_Used",
      label: "Coil Used",
      type: "select",
      id: "coil_Used",
      options: isCoilData.map((coil) => ({
        value: coil.coil_Used.toString(),
        label: coil.coil_Name,
      })),
    },
    { name: "thickness", label: "Thickness", type: "number" },
    { name: "image", label: "Upload Image", type: "file" },
  ];

  const shouldShowCloseWonFields = (stageId) => {
    return [2, 6, 7].includes(stageId);
  };
  const isCloseWonEditable = (stageId) => {
    return stageId === 2;
  };

  const shouldShowCloseLostReason = (stageId) => {
    return stageId === 3;
  };
  const validateForm = () => {
    const newErrors = {};
    if (items.length === 0) {
      newErrors.items = "At least one item is required";
    } else {
      items.forEach((item, index) => {
        if (!item.item_Code) {
          newErrors[`item_${index}`] = `Item #${index + 1} requires a product`;
        }
        if (item.qty <= 0) {
          newErrors[`qty_${index}`] = `Item #${index + 1} quantity is required`;
        }
        if (item.rate <= 0) {
          newErrors[`rate_${index}`] = `Item #${index + 1} rate is required`;
        }
      });
    }
    if (!quotation.site_Id) {
      newErrors.site_Id = "Site Name is required";
    }
    if (!quotation.quotation_Date) {
      newErrors.quotation_Date = "Quotation Date is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const fetchItemType = async () => {
    if (isItemType.length > 0) return;
    try {
      const res = await axiosInstance.get(`Item/GetAllItemType`);
      setIsItemType(res.data);
    } catch (error) {
      console.error("Error fetching GetAllItemType:", error);
    }
  };
  const fetchCoilData = async () => {
    if (isCoilData.length > 0) return;
    try {
      const res = await axiosInstance.get(`Item/GetCoilMaster`);
      setIsCoilData(res.data);
    } catch (error) {
      console.error("Error fetching GetCoilMaster:", error);
    }
  };
  const fetchCompanyData = async () => {
    if (company.length > 0) return;
    try {
      const res = await axiosInstance.get(`ManualQuotation/GetAllCompanies`);
      setCompany(res.data);
    } catch (error) {
      console.error("Error fetching GetCoilMaster:", error);
    }
  };
  useEffect(() => {
    fetchSiteData();
    fetchItemType();
    fetchCoilData();
    fetchItems();
    fetchCompanyData();
    if (manualDetailsData) {
      setQuotation((prev) => ({
        ...prev,
        ...manualDetailsData.manualQuotation,
      }));
      // setItems(manualDetailsData.items || []);
      setItems(
        manualDetailsData.items?.map((item) => ({
          ...item,
          isEditingDescription: false,
        })) || []
      );

      setTerms(manualDetailsData.terms || []);

      setIsEditing(true);
    } else {
      fetchTermsData();
    }
  }, [manualDetailsData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setQuotation((prev) => ({
      ...prev,
      [name]: name === "quotation_No" ? parseInt(value, 10) || 0 : value,
    }));
  };
  const handleInputItemChange = (e) => {
    const { name, value } = e.target;
    setNewItem((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const fetchItems = async () => {
    try {
      const response = await axiosInstance.get("Item/GetAll");
      setAllItems(response.data);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };
  const totalAmountBeforeTax = items.reduce(
    (sum, item) => sum + item.total_Amount,
    0
  );
  const discountAmount = (totalAmountBeforeTax * quotation.disc_Per) / 100;
  const total = totalAmountBeforeTax - discountAmount;
  const gstAmount = (total * quotation.gsT_Per) / 100;
  const grandTotal =
    total + gstAmount + quotation.trasportation + quotation.packing_Charge;

  const addNewItem = () => {
    setItems([
      ...items,
      {
        item_Code: "",
        item_Name: "",
        hsn_Sac: "",
        description: "",
        qty: 0,
        rate: 0,
        total_Amount: 0,
      },
    ]);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();
    formDataToSend.append("Item_Code", newItem.item_Code || 0);
    formDataToSend.append("Item_Name", newItem.item_Name);
    formDataToSend.append("Description", newItem.description);
    formDataToSend.append("Item_Rate", newItem.item_Rate);
    formDataToSend.append("Item_Type", parseInt(newItem.item_Type) || 0);
    formDataToSend.append("Item_Face", Number(newItem.item_Face));
    formDataToSend.append("Coil_Used", parseInt(newItem.coil_Used) || 0);
    formDataToSend.append("Thickness", Number(newItem.thickness));

    if (newItem.image) {
      formDataToSend.append("image", newItem.image);
    }

    try {
      await axiosInstance.post("Item/SaveUpdate", formDataToSend, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      fetchItems();
      setIsItemModalOpen(false);
      notify(
        isEditing ? "Item updated successfully!" : "Item added successfully!",
        "success"
      );
      setNewItem({
        item_Code: "",
        item_Name: "",
        description: "",
        item_Rate: "",
        item_Type: "",
        item_Face: "",
        coil_Used: "",
        thickness: "",
        image: null,
      });

      document.getElementById("fileInput").value = "";
    } catch (err) {
      console.error("Error submitting form:", err);
    }
  };
  const handleItemChange = (index, selectedOptionOrEvent) => {
    setItems((prevItems) => {
      const updatedItems = [...prevItems];
      if (selectedOptionOrEvent?.target) {
        const { name, value } = selectedOptionOrEvent.target;
        const numericValue =
          name === "qty" || name === "rate" ? parseFloat(value) || 0 : value;

        updatedItems[index] = {
          ...updatedItems[index],
          [name]: numericValue,
        };
        updatedItems[index].total_Amount =
          (updatedItems[index].qty || 0) * (updatedItems[index].rate || 0);
      } else {
        if (!selectedOptionOrEvent) {
          updatedItems[index] = {
            item_Code: "",
            item_Name: "",
            hsn_Sac: "",
            description: "",
            rate: 0,
            total_Amount: 0,
            qty: 0,
          };
        } else if (selectedOptionOrEvent.value === "add-newItem") {
          setIsItemModalOpen(true);
          return prevItems;
        } else {
          const selectedItem = allItems.find(
            (item) =>
              String(item.item_Code) === String(selectedOptionOrEvent.value)
          );

          if (selectedItem) {
            updatedItems[index] = {
              ...updatedItems[index],
              item_Code: selectedItem.item_Code || "",
              item_Name: selectedItem.item_Name || "",
              hsn_Sac: selectedItem.hsn_Sac || "",
              description: selectedItem.description || "",
              rate: selectedItem.item_Rate || 0,
            };
          }
        }
      }

      return updatedItems;
    });
  };

  const handleItemDelete = async (index) => {
    const updatedItems = [...items];
    updatedItems.splice(index, 1);
    setItems(updatedItems);
  };

  const fetchSiteData = async () => {
    try {
      const { data } = await axiosInstance.get("SiteDetail/GetAll");
      setIsSiteDetailsData(data);
    } catch (error) {
      console.error("Error fetching site details:", error);
    }
  };

  const handleSiteChange = (selectedOption) => {
    const siteId = selectedOption ? selectedOption.value : "";
    setQuotation((prev) => ({
      ...prev,
      site_Id: siteId,
    }));
    if (siteId === "add-new") {
      navigate("/transaction/site-details");
    }
  };
  useEffect(() => {
    if (manualDetailsData && isSiteDetailsData.length > 0) {
      setQuotation((prev) => ({
        ...prev,
        ...manualDetailsData.manualQuotation,
        site_Id: String(manualDetailsData.manualQuotation.site_Id),
        stageId: manualDetailsData.manualQuotation.stage_Id,
        finalAmount: manualDetailsData.manualQuotation.final_Amount || "",
        finalProfileColor:
          manualDetailsData.manualQuotation.final_Profile_Color || "",
        glassColorType:
          manualDetailsData.manualQuotation.glass_Color_Type || "",
        workCompleteDate:
          manualDetailsData.manualQuotation.work_Complete_Date?.split("T")[0] ||
          "",
        reason: manualDetailsData.manualQuotation.reason || "",
      }));
    }
  }, [manualDetailsData, isSiteDetailsData]);

  const fetchTermsData = async () => {
    try {
      setLoading(true);
      let response;
      if (quotation.quotation_No === 0 && terms.length === 0) {
        response = await axiosInstance.get("Terms/GetAll");
        const formattedTerms = response.data?.map((term, index) => ({
          seq_No: index + 1,
          term_Name: term.term_Name,
          term_Id: term.term_Id,
          isEditing: false,
        }));
        setTerms(formattedTerms);
      }
    } catch (error) {
      console.error("Error fetching terms:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleAddTerm = () => {
    setTerms((prevTerms) => {
      if (quotation.quotation_No === 0) {
        const newTermId =
          prevTerms.length > 0
            ? prevTerms[prevTerms.length - 1].term_Id + 1
            : 1;
        return [
          ...prevTerms,
          { term_Id: newTermId, term_Name: "", isEditing: true },
        ];
      } else {
        const newSeqNo =
          prevTerms.length > 0 ? prevTerms[prevTerms.length - 1].seq_No + 1 : 1;
        return [
          ...prevTerms,
          { seq_No: newSeqNo, term_Name: "", isEditing: true },
        ];
      }
    });
  };

  const handleEditTerms = (id) => {
    setTerms((prevTerms) =>
      prevTerms?.map((term) =>
        (quotation.quotation_No === 0 ? term.term_Id : term.seq_No) === id
          ? { ...term, isEditing: true }
          : term
      )
    );
  };

  const handleDeleteTerm = async (seq_No) => {
    if (quotation.quotation_No === 0) {
      setTerms((prevTerms) =>
        prevTerms.filter((term) => term.term_Id !== seq_No)
      );
    } else {
      try {
        await axiosInstance.delete(
          `ManualQuotation/DeleteManualTerm/${seq_No}`
        );
        setTerms((prevTerms) =>
          prevTerms.filter((term) => term.seq_No !== seq_No)
        );
      } catch (error) {
        console.error("Error deleting term:", error);
      }
    }
  };

  const handleTermChange = (index, event) => {
    const { name, value } = event.target;
    setTerms((prevTerms) =>
      prevTerms?.map((term, i) =>
        i === index ? { ...term, [name]: value } : term
      )
    );
  };

  const toggleDescriptionEdit = (index, isEditing) => {
    setItems((prevItems) =>
      prevItems.map((item, i) =>
        i === index ? { ...item, isEditingDescription: isEditing } : item
      )
    );
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    const isUpdate = quotation.quotation_No > 0;
    const payload = {
      manualQuotation: {
        Manual_Quotation_Id: quotation.manual_Quotation_Id || 0,
        Quotation_No: isUpdate ? quotation.quotation_No : undefined,
        Quotation_Date: quotation.quotation_Date,
        Site_Id: quotation.site_Id,
        Stage_Id: quotation.stage_Id,
        Gross_Amount: totalAmountBeforeTax,
        Disc_Per: quotation.disc_Per,
        Disc_Amount: discountAmount,
        GST_Per: quotation.gsT_Per,
        GST_Amount: gstAmount,
        Trasportation: quotation.trasportation,
        Packing_Charge: quotation.packing_Charge,
        Net_Amount: grandTotal,
        Remark: quotation.remark,
        company_Id: quotation.company_Id,
        CreatedBy: userId,
        ...(Number(quotation.stageId) === 2 && {
          Final_Amount: quotation.finalAmount,
          Final_Profile_Color: quotation.finalProfileColor,
          Glass_Color_Type: quotation.glassColorType,
          Work_Complete_Date: quotation.workCompleteDate
            ? new Date(quotation.workCompleteDate).toISOString()
            : null,
        }),
        ...(Number(quotation.stageId) === 3 && {
          Reason: quotation.reason,
        }),
      },
      items: items?.map((item) => ({
        Item_Code: item.item_Code,
        description: item.description,
        Qty: item.qty,
        Rate: item.rate,
        Total_Amount: item.total_Amount,
      })),
      terms: terms?.map((term) => ({
        Seq_No: isUpdate ? term.seq_No || 0 : 0,
        Quotation_No: isUpdate ? quotation.quotation_No : undefined,
        Term_Name: term.term_Name,
        Created_By: 1,
        Modified_By: isUpdate ? 1 : null,
      })),
    };

    try {
      setLoading(true);
      const response = await axiosInstance.post(
        "ManualQuotation/SaveOrUpdate",
        payload
      );

      if (response.data) {
        notify(
          isEditing
            ? "Manually Quotation updated successfully!"
            : "Manually Quotation added successfully!",
          "success"
        );
        setTimeout(() => navigate("/quotes/manual-quotation"), 1000);
      } else {
        notify("Something went wrong. Please try again.");
      }
    } catch (error) {
      notify("Error saving quotation:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePrint = async () => {
    try {
      setLoading(true);

      const response = await axiosInstance.get(
        `ManualQuotation/ManualQuotePrint/${quotation.quotation_No}`,
        { responseType: "blob" }
      );

      if (response.status === 200) {
        const site = isSiteDetailsData.find(
          (s) => String(s.site_Id) === String(quotation.site_Id)
        );
        const siteName = site?.site_Name?.replace(/\s+/g, "_") || "UnknownSite";
        const fileName = `Q_${quotation.quotation_No}_${siteName}.pdf`;

        const blob = new Blob([response.data], { type: "application/pdf" });
        saveAs(blob, fileName);

        const url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
      } else {
        alert("Failed to generate PDF. Please try again later.");
      }
    } catch (error) {
      console.error("Error printing quotation:", error);

      const errorMessage =
        error.response?.data?.message || "Unknown error occurred.";

      if (errorMessage.includes("Select.HtmlToPdf")) {
        alert(
          "PDF generation is currently unavailable. Please contact support."
        );
      } else {
        alert(`An error occurred while printing: ${errorMessage}`);
      }
    } finally {
      setLoading(false);
    }
  };

  const options = [
    ...isSiteDetailsData?.map((site) => ({
      value: site.site_Id?.toString() || "",
      label: site.site_Name || "Unnamed Site",
    })),
    { value: "add-new", label: "+ Add New Site Details" },
  ];
  const itemOptions = [
    ...allItems?.map((item) => ({
      value: item.item_Code?.toString() || "",
      label: item.item_Name || "Unnamed Item",
    })),
    { value: "add-newItem", label: "+ Add New Item" },
  ];
  const companyOptions = [
    ...company.map((com) => ({
      value: com.company_Id?.toString() || "",
      label: com.company_Name || "Unnamed Company",
    })),
  ];
  return (
    <>
      <Toast />
      <div className="rounded-md bg-white shadow-md border px-5 pt-6 pb-2.5">
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-2">
                <h1 className="text-lg font-bold">Manual Details</h1>
              </div>
              <button
                className="px-6 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-secondary"
                onClick={() => navigate(`/quotes/manual-quotation`)}
              >
                Back
              </button>
            </div>
            <form className="space-y-6" onSubmit={handleSave}>
              <div className="bg-white rounded-lg shadow-md p-6 border-4 border-[#f1f4f9] ">
                <div className="p-4">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="flex flex-col">
                      <label className="flex items-center text-sm font-medium mb-1">
                        Site Name
                        <FaStarOfLife className="text-red-500 ml-1 w-2 h-2" />
                      </label>
                      <Select
                        options={options}
                        value={
                          options.find(
                            (option) =>
                              String(option.value) === String(quotation.site_Id)
                          ) || null
                        }
                        // isDisabled={!!selectedSite}
                        className="mt-1"
                        isClearable
                        isSearchable
                        onChange={handleSiteChange}
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            borderColor: errors.site_Id ? "#ef4444" : "#e5e7eb",
                            boxShadow: "none",
                            "&:hover": { borderColor: "gray" },
                          }),
                          menu: (provided) => ({
                            ...provided,
                            maxHeight: "300px",
                            overflowY: "auto",
                          }),
                          menuList: (provided) => ({
                            ...provided,
                            maxHeight: "300px",
                            overflowY: "auto",
                          }),
                          option: (provided, { data }) => ({
                            ...provided,
                            backgroundColor:
                              data.value === "add-new"
                                ? "#F3F4F6"
                                : provided.backgroundColor,
                            fontWeight:
                              data.value === "add-new" ? "bold" : "normal",
                            cursor: "pointer",
                            position:
                              data.value === "add-new" ? "sticky" : "relative",
                            bottom: data.value === "add-new" ? "0" : "auto",
                          }),
                        }}
                      />{" "}
                      {errors.site_Id && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.site_Id}
                        </p>
                      )}
                    </div>
                    <div className="flex flex-col">
                      <label className="text-sm font-medium">
                        Quotation No
                      </label>
                      <input
                        type="text"
                        name="quotation_No"
                        value={quotation.quotation_No}
                        onChange={handleInputChange}
                        disabled
                        className="mt-1 block w-full rounded-md shadow-sm bg-gray px-3 py-2"
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                    <div className="flex flex-col">
                      <label className="flex items-center text-sm font-medium mb-2">
                        Company
                      </label>
                      <Select
                        options={companyOptions}
                        value={
                          quotation.company_Id
                            ? companyOptions.find(
                                (option) =>
                                  Number(option.value) ===
                                  Number(quotation.company_Id)
                              ) || null
                            : null
                        }
                        isClearable
                        isSearchable
                        onChange={(selectedOption) =>
                          setQuotation((prev) => ({
                            ...prev,
                            company_Id: selectedOption
                              ? selectedOption.value
                              : "",
                          }))
                        }
                        className="mt-1"
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            borderColor: errors.sale_Person_Id
                              ? "#ef4444"
                              : "#e5e7eb",
                            boxShadow: "none",
                            "&:hover": { borderColor: "gray" },
                          }),
                        }}
                      />
                    </div>
                    <div className="flex flex-col">
                      <label className="flex items-center text-sm font-medium mb-1">
                        Quotation Date
                        <FaStarOfLife className="text-red-500 ml-1 w-2 h-2" />
                      </label>
                      <input
                        id="quotation_Date"
                        name="quotation_Date"
                        type="date"
                        value={quotation.quotation_Date.split("T")[0]}
                        onChange={handleInputChange}
                        onFocus={(e) => e.target.showPicker()}
                        className={`mt-1 block w-full rounded-md border border-gray shadow-sm py-2 px-3 ${
                          errors.quotation_Date
                            ? "border-red-500"
                            : "border-gray-300"
                        }`}
                      />{" "}
                      {errors.quotation_Date && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.quotation_Date}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-lg shadow-md">
                <div className="bg-[#f1f4f9] px-6 py-4 border-b border-gray-200 flex justify-between items-center">
                  <h2 className="text-base font-semibold text-[#405189]">
                    Item List
                  </h2>
                </div>
                <div className="w-full overflow-x-auto p-4 space-y-4">
                  <table className=" w-full table-auto border-collapse border border-gray-300 text-sm">
                    <thead className="bg-stroke text-gray-700">
                      <tr>
                        <th className="border border-gray px-4 py-3 text-left w-8/13">
                          Item & Description
                        </th>
                        <th className="border border-gray px-4 py-3 text-left">
                          HSN/SAC
                        </th>
                        <th className="border border-gray px-4 py-3 text-left">
                          Qty
                        </th>
                        <th className="border border-gray px-4 py-3 text-left">
                          Rate
                        </th>
                        <th className="border border-gray px-4 py-3 text-left">
                          Amount
                        </th>
                        <th className="border border-gray px-4 py-3 text-left">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {items?.map((item, index) => (
                        <tr key={index} className="hover:bg-gray-50">
                          <td className="border border-gray-200 px-3 py-2 relative z-[0]">
                            <div className="flex flex-col gap-4">
                              <Select
                                options={itemOptions}
                                value={
                                  itemOptions.find(
                                    (option) =>
                                      String(option.value) ===
                                      String(items[index]?.item_Code)
                                  ) || null
                                }
                                className="min-w-[200px] z-[9999]"
                                menuPortalTarget={document.body}
                                isClearable
                                isSearchable
                                onChange={(selectedOption) =>
                                  handleItemChange(index, selectedOption)
                                }
                                name="item_Code"
                                styles={{
                                  control: (provided) => ({
                                    ...provided,
                                    borderColor: "gray",
                                    boxShadow: "none",
                                    "&:hover": { borderColor: "gray" },
                                  }),
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                  menu: (provided) => ({
                                    ...provided,
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                  }),
                                  menuList: (provided) => ({
                                    ...provided,
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                  }),
                                  option: (provided, { data }) => ({
                                    ...provided,
                                    backgroundColor:
                                      data.value === "add-newItem"
                                        ? "#F3F4F6"
                                        : provided.backgroundColor,
                                    fontWeight:
                                      data.value === "add-newItem"
                                        ? "bold"
                                        : "normal",
                                    cursor: "pointer",
                                    position:
                                      data.value === "add-newItem"
                                        ? "sticky"
                                        : "relative",
                                    bottom:
                                      data.value === "add-newItem"
                                        ? "0"
                                        : "auto",
                                  }),
                                }}
                              />
                              {/* <p className="text-gray-600 text-xs mt-1 break-words">
                              {item.description || "No description available"}
                            </p> */}
                              <div className="flex items-center gap-2">
                                {item.isEditingDescription ? (
                                  <input
                                    type="text"
                                    value={item.description}
                                    onChange={(e) =>
                                      handleItemChange(index, {
                                        target: {
                                          name: "description",
                                          value: e.target.value,
                                        },
                                      })
                                    }
                                    onBlur={() =>
                                      toggleDescriptionEdit(index, false)
                                    }
                                    className="border rounded px-2 py-1 text-xs w-full"
                                    autoFocus
                                  />
                                ) : (
                                  <>
                                    <p className="text-primary text-xs break-words flex-1">
                                      {item.description || "No description"}
                                    </p>
                                    <button
                                      type="button"
                                      onClick={() =>
                                        toggleDescriptionEdit(index, true)
                                      }
                                      className="text-primary"
                                    >
                                      <MdModeEdit className="w-4 h-4" />
                                    </button>
                                  </>
                                )}
                              </div>
                            </div>
                          </td>
                          <td className="border border-gray-200 px-3 py-2 break-words">
                            {item.hsn_Sac || "N/A"}
                          </td>
                          <td className="border border-gray-200 px-3 py-2">
                            <input
                              type="text"
                              name="qty"
                              value={items[index]?.qty || ""}
                              onChange={(e) => handleItemChange(index, e)}
                              className="border rounded p-2 w-full outline-none focus:ring-2 focus:ring-primary"
                            />
                          </td>
                          <td className="border border-gray-200 px-3 py-2">
                            <input
                              type="text"
                              name="rate"
                              value={items[index]?.rate || ""}
                              onChange={(e) => handleItemChange(index, e)}
                              className="border rounded p-2 w-full outline-none focus:ring-2 focus:ring-primary"
                            />
                          </td>
                          <td className="border border-gray-200 px-3 py-2">
                            {item.total_Amount.toFixed(2)}
                          </td>
                          <td className="border border-gray-200 px-3 py-2 text-center">
                            <button
                              type="button"
                              onClick={() =>
                                handleItemDelete(index, item.item_Code)
                              }
                              className="text-danger bg-red-100 hover:bg-red-200 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
                            >
                              <MdDeleteForever size={20} />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <button
                  type="button"
                  className="bg-secondary px-4 py-2 text-white rounded m-4"
                  onClick={addNewItem}
                >
                  + Add Another Item
                </button>

                {errors.items && (
                  <p className="text-red-500 text-xs mt-1">{errors.items}</p>
                )}
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-white rounded-lg shadow-md">
                  <div className="bg-[#f1f4f9] px-6 py-4 border-b border-gray-200 flex justify-between items-center">
                    <h2 className="text-base font-semibold text-[#405189]">
                      Terms List
                    </h2>
                  </div>
                  <div className="max-h-[350px] overflow-y-auto p-2 space-y-4">
                    <div className="space-y-3">
                      {terms?.map((term, index) => (
                        <div
                          key={index}
                          className="flex items-center border p-2 space-x-3"
                        >
                          <input
                            type="text"
                            name="term_Name"
                            value={term.term_Name || ""}
                            onChange={(e) => handleTermChange(index, e)}
                            disabled={!term.isEditing}
                            className="flex-grow px-2 py-1 w-full border rounded-md focus:ring-2 focus:ring-primary outline-none"
                          />

                          <div className="flex space-x-2">
                            <button
                              type="button"
                              className="text-success bg-green-100 p-2 rounded-md hover:bg-green-200 focus:outline-none focus:ring-2 focus:ring-green-500"
                              onClick={() =>
                                handleEditTerms(
                                  quotation.quotation_No === 0
                                    ? term.term_Id
                                    : term.seq_No
                                )
                              }
                            >
                              <MdModeEdit className="w-5 h-5" />
                            </button>
                            <button
                              type="button"
                              className="text-danger bg-red-100 p-2 rounded-md hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-red-500"
                              onClick={() =>
                                handleDeleteTerm(
                                  quotation.quotation_No === 0
                                    ? term.term_Id
                                    : term.seq_No
                                )
                              }
                            >
                              <MdDeleteForever className="w-5 h-5" />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Add Button */}
                  <div className="p-2">
                    <button
                      type="button"
                      className="bg-secondary text-white px-4 py-2 rounded-md m-1"
                      onClick={handleAddTerm}
                    >
                      + Add Term / Condition
                    </button>
                  </div>
                </div>

                <div className="bg-white rounded-lg shadow-md space-y-6">
                  <div className="bg-[#f1f4f9] px-6 py-4 border-b border-gray-200 flex justify-between items-center">
                    <h2 className="text-base font-semibold text-[#405189]">
                      Account List
                    </h2>
                  </div>
                  <div className="space-y-4 p-4">
                    <div className="flex justify-between items-center">
                      <span className="text-gray-700 font-medium">
                        Total Amount Before Tax:
                      </span>
                      <strong className="text-lg">
                        ₹{totalAmountBeforeTax.toFixed(2)}
                      </strong>
                    </div>
                    <div className="flex justify-between items-center">
                      <label
                        className="text-gray-700 font-medium"
                        htmlFor="disc_Per"
                      >
                        Discount (%):
                      </label>
                      <div className="flex items-center space-x-2">
                        <input
                          type="text"
                          id="disc_Per"
                          name="disc_Per"
                          value={quotation.disc_Per}
                          onChange={(e) =>
                            setQuotation((prev) => ({
                              ...prev,
                              disc_Per: Number(e.target.value),
                            }))
                          }
                          className="border rounded-md px-2 py-1 w-24 text-right focus:ring-1 focus:ring-primary focus:border-primary outline-none"
                        />
                        <span>= ₹{discountAmount.toFixed(2)}</span>
                      </div>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-gray-700 font-medium">Total:</span>
                      <strong className="text-lg">₹{total.toFixed(2)}</strong>
                    </div>
                    <div className="flex justify-between items-center">
                      <label
                        className="text-gray-700 font-medium"
                        htmlFor="gst_Per"
                      >
                        GST (%):
                      </label>
                      <div className="flex items-center space-x-2">
                        <input
                          type="text"
                          id="gst_Per"
                          name="gsT_Per"
                          value={quotation.gsT_Per}
                          onChange={(e) =>
                            setQuotation((prev) => ({
                              ...prev,
                              gsT_Per: Number(e.target.value),
                            }))
                          }
                          className="border rounded-md px-2 py-1 w-24 text-right focus:ring-1 focus:ring-primary focus:border-primary outline-none"
                        />
                        <span>= ₹{gstAmount.toFixed(2)}</span>
                      </div>
                    </div>
                    <div className="flex justify-between items-center">
                      <label
                        className="text-gray-700 font-medium"
                        htmlFor="transportation"
                      >
                        Transportation:
                      </label>
                      <input
                        type="text"
                        id="trasportation"
                        name="trasportation"
                        value={quotation.trasportation}
                        onChange={(e) =>
                          setQuotation((prev) => ({
                            ...prev,
                            trasportation: Number(e.target.value),
                          }))
                        }
                        className="border rounded-md px-2 py-1 w-24 text-right focus:ring-1 focus:ring-primary focus:border-primary outline-none"
                      />
                    </div>
                    <div className="flex justify-between items-center">
                      <label
                        className="text-gray-700 font-medium"
                        htmlFor="packing_Charge"
                      >
                        packing Charge:
                      </label>
                      <input
                        type="text"
                        id="packing_Charge"
                        name="packing_Charge"
                        value={quotation.packing_Charge}
                        onChange={(e) =>
                          setQuotation((prev) => ({
                            ...prev,
                            packing_Charge: Number(e.target.value),
                          }))
                        }
                        className="border rounded-md px-2 py-1 w-24 text-right focus:ring-1 focus:ring-primary focus:border-primary outline-none"
                      />
                    </div>
                    <div className="border-t pt-3 mt-4 flex justify-between items-center">
                      <span className="text-xl font-bold">Grand Total:</span>
                      <strong className="text-xl text-primary">
                        ₹{grandTotal}
                      </strong>
                    </div>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-white rounded-lg shadow-md  space-y-4">
                  <div className="bg-[#f1f4f9] px-6 py-4 border-b border-gray-200 flex justify-between items-center">
                    <h2 className="text-base font-semibold text-[#405189]">
                      Notes
                    </h2>
                  </div>
                  <div className="p-2">
                    <label className=" text-md ">Remarks</label>
                    <textarea
                      id="remark"
                      rows="4"
                      name="remark"
                      value={quotation.remark}
                      onChange={handleInputChange}
                      className="mt-2 block w-full rounded border border-gray-300 px-4 py-2 shadow-sm focus:ring-1 focus:ring-primary focus:border-primary outline-none"
                      placeholder="Enter your remarks..."
                    ></textarea>
                  </div>
                </div>
                <div
                  className={` ${
                    Number(quotation.quotation_No) === 0 ||
                    Number(quotation.stageId) === 1
                      ? "hidden"
                      : "bg-white rounded-lg shadow-md p-6 space-y-4 "
                  }`}
                >
                  {shouldShowCloseWonFields(Number(quotation.stageId)) && (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                      <label className="block text-md font-medium mt-2">
                        Final Amount
                      </label>
                      <input
                        type="text"
                        name="finalAmount"
                        value={quotation.finalAmount || ""}
                        onChange={handleInputChange}
                        disabled={
                          !isCloseWonEditable(Number(quotation.stageId))
                        }
                        className="block w-full rounded-md border border-gray shadow-sm py-2 px-3"
                      />

                      <label className="block text-md font-medium">
                        Final Profile Color
                      </label>
                      <input
                        type="text"
                        name="finalProfileColor"
                        value={quotation.finalProfileColor || ""}
                        onChange={handleInputChange}
                        disabled={
                          !isCloseWonEditable(Number(quotation.stageId))
                        }
                        className="block w-full rounded-md border border-gray shadow-sm py-2 px-3"
                      />

                      <label className="block text-md font-medium">
                        Glass Color Type
                      </label>
                      <input
                        type="text"
                        name="glassColorType"
                        value={quotation.glassColorType || ""}
                        onChange={handleInputChange}
                        disabled={
                          !isCloseWonEditable(Number(quotation.stageId))
                        }
                        className="block w-full rounded-md border border-gray shadow-sm py-2 px-3"
                      />

                      <label className="block text-md font-medium">
                        Close Won Date
                      </label>
                      <input
                        type="date"
                        name="closeWonDate"
                        value={quotation.workCompleteDate || ""}
                        onChange={handleInputChange}
                        disabled={
                          !isCloseWonEditable(Number(quotation.stageId))
                        }
                        className="block w-full rounded-md border border-gray shadow-sm py-2 px-3"
                      />
                    </div>
                  )}
                  {shouldShowCloseLostReason(Number(quotation.stageId)) && (
                    <>
                      <label className="block text-md font-medium mb-1 mt-2">
                        Reason
                      </label>
                      <textarea
                        name="reason"
                        value={quotation.reason || ""}
                        onChange={handleInputChange}
                        rows="4"
                        className="mt-2 block w-full rounded border border-gray-300 px-4 py-2 shadow-sm focus:ring-primary focus:border-primary break-words"
                        placeholder="Enter reason here..."
                      ></textarea>
                    </>
                  )}
                </div>
              </div>
              <div className="flex gap-4">
                {(isEditing ? permission.isUpdate : permission.isInsert) && (
                  <button
                    className="px-6 py-2 border border-transparent text-sm font-medium rounded text-white bg-primary"
                    type="submit"
                  >
                    {isEditing ? "Update" : "Save"}
                  </button>
                )}
                {isEditing && (
                  <button
                    type="button"
                    className="px-4 py-2 border border-transparent text-sm font-medium rounded text-white bg-primary"
                    onClick={() => handlePrint(manualDetailsData.quotation_No)}
                  >
                    Print
                  </button>
                )}
                <button
                  type="button"
                  className="px-4 py-2 border border-gray text-sm font-medium rounded bg-white"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </button>
              </div>
            </form>
          </>
        )}
      </div>
      <Model
        isOpen={isItemModalOpen}
        onClose={() => setIsItemModalOpen(false)}
        name="Add New Item"
      >
        <FormFields
          onSubmit={handleSubmit}
          setIsModelOpen={setIsItemModalOpen}
          formData={newItem}
          handleInputChange={handleInputItemChange}
          fields={fields}
          onClear={() => setIsItemModalOpen(false)}
          isEditing={isEditing}
        />
      </Model>
    </>
  );
};

export default ManualDetails;
